import { render } from "./payment.vue?vue&type=template&id=664b8c38&scoped=true"
import script from "./payment.vue?vue&type=script&lang=js"
export * from "./payment.vue?vue&type=script&lang=js"

import "./payment.vue?vue&type=style&index=0&id=664b8c38&scoped=true&lang=scss"

import exportComponent from "F:\\my-work\\company\\yuanxi\\yuanxi-csspw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-664b8c38"]])

export default __exports__